import { useSelector } from "react-redux";
import store from "../storeWire";
import {
    fetchOrderList,
    fetchHeaderOrderDetail,
    sendEmailOrder,
    fetchOrderListByLineItem,
    fetchOrderListByDelivery,
    placeYourOrder,
    fetchPlaceOrderItems,
    orderDownloadSingleInvoice,
    exportOrder,
    fetchExportOrderCount,
    setPlaceOrderLoading,
    fetchManufacturerList
} from "../store/slice/model/Order";
import OrderRepository from "src/repository/OrderRepository";

export function useOrderStore() {
    const order_list = useSelector((state) => state.entities.model_Order.orderList)
    const header_order_detail = useSelector((state) => state.entities.model_Order.headerOrderDetail)
    const order_line_item_list = useSelector((state) => state.entities.model_Order.orderLineItemList)
    const order_delivery_list = useSelector((state) => state.entities.model_Order.orderDeliveryList)
    const place_order_item_list = useSelector((state) => state.entities.model_Order.placeOrderItemList)
    const order_export_count = useSelector((state) => state.entities.model_Order.orderExportCount)
    const order_manufacturer_list = useSelector((state) => state.entities.model_Order.orderManuFactureList)

    let data = {
        order_list,
        header_order_detail,
        order_line_item_list,
        order_delivery_list,
        place_order_item_list,
        order_export_count,
        order_manufacturer_list
    };
    let fetch = {
        fetch_order_list: async (params) => {
            return await store.dispatch(fetchOrderList(params))
        },
        fetch_header_order_detail: async (params) => {
            return await store.dispatch(fetchHeaderOrderDetail(params))
        },
        send_email_order: async (params) => {
            return await store.dispatch(sendEmailOrder(params))
        },
        fetch_order_list_by_line_item: async (params) => {
            return await store.dispatch(fetchOrderListByLineItem(params))
        },
        fetch_order_list_by_delivery: async (params) => {
            return await store.dispatch(fetchOrderListByDelivery(params))
        },
        fetch_place_order_items: async (orderId) => {
            return await store.dispatch(fetchPlaceOrderItems(orderId))
        },
        fetch_order_export_count: async() => {
            return await store.dispatch(fetchExportOrderCount())
        },
        fetch_manuFacturer_list: async () => {
            return await store.dispatch(fetchManufacturerList())
        },
        send_order_po_item_email: async(params) => {
            return await new OrderRepository().sendOrderPOLineItemEmail(params)
        },
        fetch_order_return_reason: async() => {
            return await new OrderRepository().fetchOrderReturnReasonList()
        } 
    };
    let set = {
        place_your_order: async (params) => {
            return await store.dispatch(placeYourOrder(params))
        },
        order_download_single_invoice: async (params) => {
            return await store.dispatch(orderDownloadSingleInvoice(params))
        },
        export_order: async (params) => {
            return await store.dispatch(exportOrder(params))
        },
        place_order_return_request: async(params) => {
            return await new OrderRepository().placeOrderReturnRequest(params)
        }
    };
    return [data, fetch, set]
}